require('./brokerStocksSaleOrderStep1.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKInput } = require('commonsComponents/OKInput');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    MYPROFILE_BROKER_URL,
    BROKER_CORPORATE_OPERATIONS_URL
 } = require('constants/index');
const CLASS_NAME = 'broker-stocks-sale-order-step1';

class BrokerStocksSaleOrderStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onChangeTitlesAmount(event.target.value);
    }

    buildContent() {
        const {
            immBrokerStocksSaleOrder,
            actions,
            cancelButton,
            nextButton
        } = this.props;
        const immFirstStep = immBrokerStocksSaleOrder.getIn(['steps', FIRST_STEP]);
        const titlesAmountLabel = formatText('stocksSaleOrder-titlesAmount');
        const titlesAmount = immFirstStep.get('titlesAmount');
        const errorState = immFirstStep.getIn(['flagsError', 'titlesError']);

        return (
            <WizardStep
                actions={actions}
                cancelButton={cancelButton}
                nextButton={nextButton}
                position="first"
            >
                <h4 className={`${CLASS_NAME}__header-title`}>
                    <FormattedText
                        value="stocksSaleOrder-saleInformation"
                    />
                </h4>
                <div className={`${CLASS_NAME}__info`}>
                    <FormattedText
                        value="stocksSaleOrder-completeFollowingInformation"
                    />
                </div>
                <div className={`${CLASS_NAME}__field`}>
                    <div className={`${CLASS_NAME}__input`}>
                        <span className={`${CLASS_NAME}__titles`}>
                            {titlesAmountLabel}
                        </span>
                    </div>
                    <OKInput 
                        value={titlesAmount} 
                        onChange={this.handleChange}
                        errorState={errorState}
                        errorMessage={formatText('corporatesOperations-titlesAmountError')}
                    />
                </div>
            </WizardStep>
        );
    }

    buildMifidBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerMyWallet'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('corporatesOperations-corporatesOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            }
        ];
    }

    render() {
        return this.buildContent();
    }
        
}

BrokerStocksSaleOrderStep1.propTypes = {
    immBrokerStocksSaleOrder: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerStocksSaleOrderStep1.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerStocksSaleOrderStep1;